import {InjectionToken} from '@angular/core'
import {PermissionsEmbeddedService} from '@service/permissions/permissions.embedded.service'
import {PermissionsService} from '@service/permissions/permissions.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `PermissionsService`.
 *
 * @description
 * Devuelve `PermissionsEmbeddedService` en modo embebido y
 * `PermissionsService` en modo standalone. `PermissionsService` resuelve
 * los permisos del usuario que consumen los guards de ruta, las
 * directivas de permisos y las facades para habilitar/deshabilitar
 * acciones en la UI.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `PermissionsService`.
 */
export function providerPermissionsServiceFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new PermissionsEmbeddedService() : new PermissionsService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `PermissionsService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerPermissionsServiceFactory}.
 */
export const PermissionsServiceToken = new InjectionToken<PermissionsService>('PermissionsService')
